import "./style.css";
import Experience from "./Experience/Experience";

const experience = new Experience({
    targetElement: document.querySelector(".experience"),
});
